/** saves in our store info from our current process steps
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customerscreationprocessSteps
*/
export const SAVE_PROCESS_STEPS_INFO = (state, payload) => {
    state.processStepsInfo = payload.processSteps
}

/** saves in our store literary abilities for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsliteraryAbilities
*/
export const SAVE_LITERARY_ABILITIES = (state, payload) => {
    state.literaryAbilities = payload.literaryAbilities.map(item => {
        return { id: item, text: item }
    })
}

/** saves in our store countries for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovscountries
*/
export const SAVE_PROCESS_MARITAL_STATUS = (state, payload) => {
    state.maritalStatuses = payload.maritalStatuses.map(item => {
        return { ...item, id: item.maritalStatus, text: item.description }
    })
}

/** saves in our store countries for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovscountries
*/
export const SAVE_PROCESS_COUNTRIES = (state, payload) => {
    state.countries = payload.countries.map(item => {
        return { id: item, text: item }
    })
}

/** saves in our store provinces for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsprovinces
*/
export const SAVE_PROCESS_PROVINCES = (state, payload) => {
    state.provinces = payload.provinces.map(item => {
        return { id: item, text: item }
    })
}

/** saves in our store counties for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customerscreationlovscounties
*/
export const SAVE_PROCESS_COUNTIES = (state, payload) => {
    state.counties = payload.counties.map(item => {
        return { id: item, text: item }
    })
}

/** saves in our store counties of a province for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customerscreationlovscounties
*/
export const SAVE_PROCESS_PROVINCE_COUNTIES = (state, payload) => {
    state.provinceCounties = payload.counties.map(item => {
        return { id: item, text: item }
    })
}

/** saves in our store occupations for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsprocessOccupation
*/
export const SAVE_PROCESS_OCCUPATION = (state, payload) => {
    state.processOccupation = payload.customerCreationProcessOccupations.map(item => {
        return { ...item, text: item.description }
    })
}

/** saves in our store professions for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsprofessions
*/
export const SAVE_PROCESS_PROFESSIONS = (state, payload) => {
    state.professions = payload.professions.map(item => {
        return { id: item, text: item }
    })
}

/** saves in our store professions for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsprofessions
*/
export const SAVE_PROCESS_CONTRACTUAL_TIES = (state, payload) => {
    state.contractualTies = payload.customerCreationContractualTies.map(item => {
        return { ...item, text: item.description }
    })
}

/** saves in our store professional activities for create account process
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsprofessionalActivities
*/
export const SAVE_PROCESS_ACTIVITIES = (state, payload) => {
    state.professionalActivities = payload.professionalActivities.map(item => {
        return { id: item, text: item }
    })
}

/** saves in our store agencies provinces
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_agenciesprovinces
*/
export const SAVE_PROCESS_AGENCIES_PROVINCES = (state, payload) => {
    state.provincesAgencies = payload.provinces.map(item => {
        return { id: item, text: item }
    })
}

/** saves in our store branches
@payload {Object} - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_branches
*/
export const SAVE_PROCESS_BRANCHES = (state, payload) => {
    state.branches = payload.page.map(item => {
        return { ...item, text: item.name }
    })
}
